import { apiSlice } from "./apiSlice";
import { ORDERS_URL } from "../constants";

const ordersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createOrder: builder.mutation({
      query: (data) => ({
        url: `${ORDERS_URL}/createOrder`,
        method: "POST",
        body: data,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
    getMyOrders: builder.query({
      query: (data) => ({
        url: `${ORDERS_URL}/getMyOrders?${data?.query ? data?.query : ""}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${data?.token}`,
        },
      }),
    }),
    getOrdersById: builder.query({
      query: (data) => ({
        url: `${ORDERS_URL}/getOrders/${data.orderId}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${data?.token}`,
        },
      }),
    }),
  }),
});

export const {
  useCreateOrderMutation,
  useGetMyOrdersQuery,
  useGetOrdersByIdQuery,
} = ordersApiSlice;
